import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { Icon } from '@millionshow/client-libs';

@Component({
  selector: 'app-not-found',
  imports: [CommonModule, Icon],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  isLoading = input<boolean>(false);
  query = model<string>('');
}
